import React, { useEffect } from 'react';
import { Translation, getI18n } from 'react-i18next';
import { Table } from 'antd';
import { withRouter } from 'react-router';
import ListActions from '../../../elements/components/ListActions';

import {
  getColumnSearchProps,
  getColumnDateRangeProps,
} from '../../../elements/components/TableColumnFilters';
import { pathTo } from '../../../Routes';
import Format from '../../../../../lib/Format';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

const PartnershipFormAnswersList = ({
  component,
  page,
  limit,
  order,
  total,
  filter,
  load,
  history,
  remove,
  ...props
}) => {
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    delete filter[dataIndex];
    history.push(
      QueryString.append(props.location.pathname, { order, ...filter })
    );
  };

  const columns = [
    {
      title: getI18n().t('table_header_id'),
      dataIndex: 'id',
      key: 'id',
      defaultSortOrder:
        order === 'id.asc' ? 'ascend' : order === 'id.desc' ? 'descend' : null,
      sorter: true,
    },
    {
      title: getI18n().t('partnership_form_answer_care_guide_name'),
      dataIndex: 'care_guide_name',
      key: 'care_guide_name',
      ...getColumnSearchProps(
        'care_guide_name',
        handleSearch,
        handleReset,
        getI18n().t('partnership_form_answer_care_guide_name'),
        filter
      ),
    },
    {
      title: getI18n().t('partnership_form_answer_partnership_name'),
      dataIndex: 'partnership_name',
      key: 'partnership_name',
      ...getColumnSearchProps(
        'partnership_name',
        handleSearch,
        handleReset,
        getI18n().t('partnership_form_answer_partnership_name'),
        filter
      ),
    },
    {
      title: getI18n().t('partnership_form_answer_profile'),
      dataIndex: 'profile_username',
      key: 'username',
      ...getColumnSearchProps(
        'username',
        handleSearch,
        handleReset,
        getI18n().t('partnership_form_answer_profile'),
        filter
      ),
    },
    {
      title: getI18n().t('partnership_form_answer_form_id'),
      dataIndex: 'form_id',
      key: 'form_id',
      ...getColumnSearchProps(
        'form_id',
        handleSearch,
        handleReset,
        getI18n().t('partnership_form_answer_form_id'),
        filter
      ),
    },
    {
      title: getI18n().t('partnership_form_answer_entry_id'),
      dataIndex: 'entry_id',
      key: 'entry_id',
      ...getColumnSearchProps(
        'entry_id',
        handleSearch,
        handleReset,
        getI18n().t('partnership_form_answer_entry_id'),
        filter
      ),
    },
    {
      title: getI18n().t('table_header_created_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => Format.date(date),
      defaultSortOrder:
        order === 'created_at.asc'
          ? 'ascend'
          : order === 'created_at.desc'
          ? 'descend'
          : null,
      sorter: true,
      ...getColumnDateRangeProps(
        'created_at',
        handleSearch,
        handleReset,
        filter
      ),
    },
    {
      title: getI18n().t('table_header_actions'),
      dataIndex: 'id',
      key: 'actions',
      render: (id) => (
        <ListActions
          id={id}
          page={page}
          limit={limit}
          order={order}
          filter={filter}
          load={load.bind(this)}
          remove={remove.bind(this)}
          actionView={true}
          actionDelete={true}
          actionEdit={false}
          viewScreen={'PartnershipFormAnswerViewScreen'}
        />
      ),
    },
  ];

  const pagination = {
    current: page,
    pageSize: limit,
    total: total,
    showSizeChanger: false,
    position: ['bottomCenter'],
  };

  const handleTableChange = (pagination, filters, sorter) => {
    let path = props.location.pathname;
    const params = {};

    // handle pagination
    if ('current' in pagination && pagination['current']) {
      path = pathTo(component, { page: pagination['current'] });
    }

    // handle sorting
    if ('field' in sorter && 'order' in sorter) {
      if (sorter['field'] && sorter['order']) {
        const order =
          sorter['field'] +
          '.' +
          (sorter['order'] === 'ascend' ? 'asc' : 'desc');
        params['order'] = order;
      }
    }

    // handle filters
    if (filters) {
      for (const key in filters) {
        if (filters[key]) {
          params[key] = filters[key].join(',');
        }
      }
    }

    history.push(QueryString.append(path, params));
  };

  const filterString = JSON.stringify(filter);
  useEffect(() => {
    load(page, limit, order, JSON.parse(filterString));
  }, [page, limit, order, filterString, load]);

  return (
    <Translation>
      {(t) => (
        <Table
          dataSource={props.list}
          columns={columns}
          pagination={page === 1 && total <= limit ? false : pagination}
          loading={props.isLoading}
          scroll={{ x: true }}
          onChange={handleTableChange}
        />
      )}
    </Translation>
  );
};

export default withRouter(PartnershipFormAnswersList);

Logger.log('silly', `PartnershipFormAnswersList loaded.`);
